import React, { PureComponent } from 'react';

export default class NotFound extends PureComponent {
  render() {
    return (
      <>
        <div>Not found!</div>
      </>
    );
  }
}
